'use strict';

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index$1 = require('../../../atoms/IconSvg/index.js');
var classnames = require('classnames');
var index$4 = require('../../SnackBar/index.js');
var index = require('../store/index.js');
var index$2 = require('../WizardProgressItem/index.js');
var index$3 = require('../WizardActions/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);

var Wizard = function Wizard(_ref) {
  var backButton = _ref.backButton,
      children = _ref.children,
      className = _ref.className,
      finishButton = _ref.finishButton,
      forwardButton = _ref.forwardButton,
      onClose = _ref.onClose,
      title = _ref.title;

  var _useContext = React.useContext(index.default),
      currentStep = _useContext.currentStep,
      error = _useContext.error,
      onCloseError = _useContext.onCloseError,
      steps = _useContext.steps;

  var renderCurrentStep = React.cloneElement(steps.length > 1 ? children[currentStep] : children, {
    index: currentStep
  });
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classnames__default['default']('ds-organisms-wizard', _rollupPluginBabelHelpers.defineProperty({}, className, !!className))
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-organisms-wizard-header"
  }, title, /*#__PURE__*/React__default['default'].createElement("button", {
    className: "ds-organisms-wizard-close",
    onClick: onClose,
    type: "button"
  }, /*#__PURE__*/React__default['default'].createElement(index$1, {
    className: "ds-organisms-wizard-cross",
    icon: "cross"
  }))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-organisms-wizard-progress"
  }, steps.map(function (item, index) {
    return /*#__PURE__*/React__default['default'].createElement(index$2, {
      index: index,
      key: "".concat(item.title).concat(index),
      title: item.title
    });
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-organisms-wizard-content"
  }, renderCurrentStep), /*#__PURE__*/React__default['default'].createElement(index$3, {
    backButton: backButton,
    finishButton: finishButton,
    forwardButton: forwardButton
  }), error && /*#__PURE__*/React__default['default'].createElement(index$4, {
    error: true,
    title: error.name,
    onDismiss: onCloseError
  }, error.message));
};

Wizard.propTypes = {
  backButton: PropTypes__default['default'].string.isRequired,
  children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].node), PropTypes__default['default'].node]),
  className: PropTypes__default['default'].string,
  finishButton: PropTypes__default['default'].string.isRequired,
  forwardButton: PropTypes__default['default'].string.isRequired,
  onClose: PropTypes__default['default'].func.isRequired,
  title: PropTypes__default['default'].string.isRequired
};
Wizard.defaultProps = {
  children: null,
  className: undefined
};

module.exports = Wizard;
